import React, { useState } from "react";
import "../styles/Header.css";
import wp from "../assets/mobil/wp.png";
import ins from "../assets/mobil/ins.png";
import mail from "../assets/mobil/mail.png";
import { FaPhoneAlt } from "react-icons/fa";

const Header: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleToggle = () => {
    setMenuOpen((prev) => !prev);
  };

  return (
    <div className={`header custom-header-layout${menuOpen ? " expanded" : ""}`}>
      {/* Mobil Toggle */}
      <div className="mobile-toggle" onClick={handleToggle}>
        <span className="current-info">MENÜ</span>
        <span className="toggle-icon">&#9776;</span>
      </div>
      <div className="header-content">
        <div className="header-section header-left">
          <div className="header-item">
            <a href="tel:+902128125062" target="_blank" rel="noopener noreferrer">
              <FaPhoneAlt className="social-icon-svg" aria-hidden="true" focusable="false" />
              <span className="header-text">0212 812 50 62</span>
            </a>
          </div>
          <div className="header-item">
            <a href="https://api.whatsapp.com/send/?phone=%2B905465248849&text&type=phone_number&app_absent=0" target="_blank" rel="noopener noreferrer">
              <img src={wp} alt="WhatsApp" className="social-icon" />
              <span className="header-text">0546 524 88 49</span>
            </a>
          </div>
        </div>
        <div className="header-section header-center">
          <div className="header-item">
            <a href="https://www.instagram.com/metalkiymetlimadenler/" target="_blank" rel="noopener noreferrer">
              <img src={ins} alt="Instagram" className="social-icon" />
              <span className="header-text">@metalkiymetlimadenler</span>
            </a>
          </div>
        </div>
        <div className="header-section header-right">
          <div className="header-item">
            <a href="mailto:info@metalkiymetlimadenler.com.tr" target="_blank" rel="noopener noreferrer">
              <img src={mail} alt="Mail" className="social-icon" />
              <span className="header-text">info@metalkiymetlimadenler.com.tr</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;